/**
 * STABILITY-CRITICAL: mexe em cache offline/atualização de versão do PWA em produção;
 * antes de alterar, leia docs/llm/slices/architecture-overview.md e alinhe com o
 * responsável pelo sync.
 *
 * Por que é perigoso: apaga TODOS os caches (inclusive o precache offline), desregistra o
 * service worker e recarrega a página em 500 ms, sem olhar o estado do sync. Se a rede cair
 * depois de apagar, o app fica sem modo offline. É o caminho de EMERGÊNCIA (botão "Atualizar
 * versão" e logout/limpeza). A atualização rotineira de versão NÃO passa por aqui: ver
 * utils/updateAnnouncer.ts (anuncia, e só ativa a pedido do usuário com o sync parado).
 */

import * as serviceWorker from '../serviceWorker'
import { recordEvent } from '../observability/events'

export default function clearCache(): void {
  // if ('caches' in window) {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name)
    })
    void recordEvent({
      level: 'info',
      category: 'outro',
      action: 'cache_cleared',
      payload: { cacheCount: names.length },
    })
    serviceWorker.unregister()
    serviceWorker.register()
  })

  setTimeout(function () {
    window.location.reload()
  }, 500)
  // }
}
